import React, { useEffect, useState } from "react";
import Dashboard from "./Components/dashboard/Dashboard";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import SignIn from "./Auth/SignIn/SignIn";
import ForgetPassword from "./Auth/Forget-Password/ForgetPassword";
import { getCurrentUser } from "aws-amplify/auth";
import ProtectRoute from "./Authenticate/ProtectRoute";
import RequestNewPassword from "./Auth/RequestNewPassword/RequestNewPassword";
import ResetPassword from "./Auth/ResetPassword/ResetPassword";
import PageNotFound from "./Pages/404Page/PageNotFound";
import { AmplifyConfig } from "./amplify/config";

export default function App() {
  AmplifyConfig.configure();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isInvalidUrl, setIsInvalidUrl] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const checkAuthState = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };
    checkAuthState();

    if (location.hash.length !== 0) {
      setIsInvalidUrl(true);
    }
  }, [location.hash]);

  const invalidURLState = () => {
    setIsInvalidUrl(false);
  };

  // Show loading while checking auth
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {isInvalidUrl === true ? (
        <PageNotFound invalidUrlState={invalidURLState} />
      ) : (
        <Routes>
          <Route
            path="/:hotelId"
            element={<ProtectRoute Component={Dashboard} />}
          />
          <Route path="/" element={<ProtectRoute Component={Dashboard} />} />
          <Route path="/signIn" element={<SignIn />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/requestNewPassword" element={<RequestNewPassword />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route
            path="*"
            element={<PageNotFound invalidUrlState={invalidURLState} />}
          />
        </Routes>
      )}
    </>
  );
}
